import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "@/AppRoutes";
import { PageTracker } from "@/components/site/PageTracker";

const App = () => (
  <BrowserRouter>
    <PageTracker />
    <AppRoutes />
  </BrowserRouter>
);

export default App;
